import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'date-vencimento-alvara',
  templateUrl: './date-vencimento-alvara.component.html',
  styleUrls: ['./date-vencimento-alvara.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DateVencimentoAlvaraComponent implements OnInit {

  now: string = new Date().toISOString().split('T')[0];
  
  constructor() { }
  
  ngOnInit() { }
  
}
